import TwoFactorForm from "@/components/TwoFactor/TwoFactorForm";
import { Dialog } from "@mui/material";
import { useEffect, useState } from "react";
import { TWO_FACTOR_COMPLETED_EVENT, TWO_FACTOR_NEEDED_EVENT } from "../api";

export default function TwoFactorProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isPending2FA, setIsPending2FA] = useState(false);
  useEffect(() => {
    const listener = () => {
      setIsPending2FA(true);
    };
    window.addEventListener(TWO_FACTOR_NEEDED_EVENT, listener);
    return () => {
      window.removeEventListener(TWO_FACTOR_NEEDED_EVENT, listener);
    };
  }, []);
  const handleComplete = () => {
    setIsPending2FA(false);
    const event = new CustomEvent(TWO_FACTOR_COMPLETED_EVENT);
    window.dispatchEvent(event);
  };
  return (
    <>
      <Dialog open={isPending2FA}>
        <TwoFactorForm onCompleted={handleComplete} />
      </Dialog>
      {children}
    </>
  );
}
